const getUniqueValues = (values) =>
  Array.from(new Set(values.filter((value) => String(value || "").trim())));

const getPurchasedFieldMapping = (payment) => {
  const spreadsheetData = payment?.spreadsheetData || {};
  const paymentFieldMapping = payment?.fieldMapping || {};
  return Object.keys(paymentFieldMapping).length
    ? paymentFieldMapping
    : spreadsheetData.mapping || {};
};

const getPurchasedFieldNames = (payment) =>
  getUniqueValues(Object.values(getPurchasedFieldMapping(payment)));

const getRegenerationCompatibility = (fields, payment) => {
  const purchasedFieldNames = getPurchasedFieldNames(payment);
  const currentFieldNames = Object.keys(fields || {});
  const currentFieldNamesSet = new Set(currentFieldNames);
  const sharedFieldNames = purchasedFieldNames.filter((fieldName) =>
    currentFieldNamesSet.has(fieldName)
  );
  const visibleSharedFieldNames = sharedFieldNames.filter(
    (fieldName) => fields?.[fieldName]?.enabled === true
  );
  const visibleCurrentFieldNames = currentFieldNames.filter(
    (fieldName) => fields?.[fieldName]?.enabled === true
  );

  return {
    currentFieldNames,
    purchasedFieldNames,
    sharedFieldNames,
    visibleCurrentFieldNames,
    visibleSharedFieldNames,
    requiresFieldMapping: sharedFieldNames.length === 0,
    requiresVisibleSharedField:
      sharedFieldNames.length > 0 && visibleSharedFieldNames.length === 0,
  };
};

const mapPurchasedAttendeesToCurrentFields = (attendees, mapping) =>
  (attendees || []).map((attendee) =>
    Object.entries(mapping || {}).reduce(
      (mappedAttendee, [purchasedFieldName, currentFieldName]) => {
        if (currentFieldName) {
          mappedAttendee[currentFieldName] =
            attendee?.[purchasedFieldName] ?? "";
        }
        return mappedAttendee;
      },
      {}
    )
  );

module.exports = {
  getPurchasedFieldMapping,
  getPurchasedFieldNames,
  getRegenerationCompatibility,
  mapPurchasedAttendeesToCurrentFields,
};
